import { Link } from "react-router-dom";
import styled from "styled-components";
import PrevNextPagination from "../assets/PrevNextPagination";
import CarCard from "./CarCard";
import useTranslation from "../../hooks/useTranslation";
import { ArrowIcon } from "../assets/Icons";

const SpecialCars = ({ title, cars, ...props }) => {
  const { language } = useTranslation();
  return (
    <StyledSection language={language}>
      <div className="header">
        <TitleContainer>
          <h2>{title}</h2>
          <ViewAllLink language={language} to="/cars">
            {language === "en" ? "See all cars" : "عرض كل السيارات"}
            <ArrowIcon />
          </ViewAllLink>
        </TitleContainer>
        <div className="desktop-only">
          <PrevNextPagination />
        </div>
      </div>
      <div className="cars">
        {cars.map(car_detail => (
          <Link to={"/car/" + car_detail.car.id}>
            <CarCard car_detail={car_detail} homePage={props.homePage} />
          </Link>
        ))}
      </div>
    </StyledSection>
  );
};

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-weight: 700;
    font-size: 1.528vw;
    line-height: 2.222vw;
    color: #0d0a19;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 4.267vw;
      line-height: 6.4vw;
    }
  }
`;

const ViewAllLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.556vw;
  padding-inline-start: 1.111vw;
  font-size: 1.111vw;
  font-weight: 600;
  color: #154cd6;
  text-decoration: none;

  svg {
    width: 1.111vw;
    height: 1.111vw;
    transform: ${props => (props.language !== "en" ? "rotate(180deg)" : "none")};
  }

  @media (max-width: 768px) {
    padding-inline-start: 2vw;
    font-size: 4vw;

    svg {
      width: 4vw;
      height: 4vw;
    }
  }
`;

const StyledSection = styled.div`
  * {
    font-family: ${props => (props.language === "en" ? "Inter" : "Almarai")};
  }
  direction: ${props => (props.language === "en" ? "ltr" : "rtl")};
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2.222vw;
  }
  .cars {
    display: flex;
    align-items: center;
    gap: calc(24 / 1440 * 100vw);
  }

  @media (max-width: 768px) {
    .header {
      margin-bottom: 4.267vw;
      margin-right: 0;
      margin-left: 4.267vw;
    }
    .cars {
      gap: 3.2vw;
      overflow-y: scroll;
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      scrollbar-width: none; /* Firefox */
      align-items: flex-start;
    }
    .cars::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }
`;

export default SpecialCars;
